/* Featured pages coverflow slider; loads Swiper from jsDelivr (from the reference page). */
(() => {
    const sectionId = "bspdp-slider";
    const sliderId = `Slider-${sectionId}`;
    const uniqueSlideCount = 9;
    const controllerRegistryName = '__sectionStoreSlider2Controllers';
    const libraryRegistryName = '__sectionStoreSwiper1220';
    const libraryUrl = 'https://cdn.jsdelivr.net/npm/swiper@12.2.0/swiper-bundle.min.js';
    const libraryIntegrity = 'sha256-HjE1VbBMubUnO3qBcVhwigX1jhj5HZekI52rb2jSPEo=';
    const libraryLoadTimeoutMs = 8000;
    const sliderElement = document.getElementById(sliderId);
    const controllers = window[controllerRegistryName] = window[controllerRegistryName] || {};

    if (!sliderElement) return;

    if (controllers[sectionId] && typeof controllers[sectionId].destroy === 'function') {
      controllers[sectionId].destroy();
    }

    let sliderInstance = null;
    let controllerDestroyed = false;
    let initRequestToken = 0;

    const eventContainsSlider = (event) => {
      const target = event && event.target;

      if (!target || typeof target.contains !== 'function') return false;
      return target === sliderElement || target.contains(sliderElement);
    };

    const restorePreview = () => {
      sliderElement.classList.add('preview');
    };

    const applyAccessibleSlideLabels = (swiper) => {
      if (!swiper || !swiper.slides || uniqueSlideCount < 1) return;

      swiper.slides.forEach((slide) => {
        const originalIndex = Number(slide.dataset.sliderOriginalIndex);

        if (Number.isInteger(originalIndex)) {
          slide.setAttribute('aria-label', `${originalIndex + 1} / ${uniqueSlideCount}`);
        }
      });
    };

    const destroySlider = () => {
      if (sliderInstance && !sliderInstance.destroyed) {
        try {
          sliderInstance.destroy(true, true);
        } catch (error) {
          console.error(`Slider ${sectionId} failed to clean up safely.`, error);
        }
      }

      sliderInstance = null;
      restorePreview();
    };

    const restorePreviousSwiperGlobal = (previousSwiper) => {
      if (typeof previousSwiper === 'undefined') {
        try {
          const deleted = delete window.Swiper;
          if (!deleted) window.Swiper = undefined;
        } catch (error) {
          window.Swiper = undefined;
        }
      } else {
        window.Swiper = previousSwiper;
      }
    };

    const loadSwiperLibrary = () => {
      const existingState = window[libraryRegistryName];

      if (existingState && typeof existingState.SwiperClass === 'function') {
        return Promise.resolve(existingState.SwiperClass);
      }

      if (existingState && existingState.promise) {
        return existingState.promise;
      }

      const state = {
        SwiperClass: null,
        promise: null
      };

      state.promise = new Promise((resolve, reject) => {
        const previousSwiper = window.Swiper;
        const scriptElement = document.createElement('script');
        const scriptParent = document.head || document.documentElement;
        let settled = false;
        let timeoutId = null;

        const clearLoadTimeout = () => {
          if (timeoutId !== null) {
            window.clearTimeout(timeoutId);
            timeoutId = null;
          }
        };

        const finishWithError = (message) => {
          if (settled) return;
          settled = true;
          clearLoadTimeout();
          restorePreviousSwiperGlobal(previousSwiper);
          scriptElement.remove();

          if (window[libraryRegistryName] === state) {
            delete window[libraryRegistryName];
          }

          reject(new Error(message));
        };

        scriptElement.src = libraryUrl;
        scriptElement.async = true;
        scriptElement.integrity = libraryIntegrity;
        scriptElement.crossOrigin = 'anonymous';
        scriptElement.referrerPolicy = 'no-referrer';
        scriptElement.dataset.sectionStoreSwiperVersion = '12.2.0';

        scriptElement.addEventListener('load', () => {
          if (settled) {
            /*
              A request removed after the timeout can still complete in
              some browsers. Restore the prior global again so a late
              UMD execution cannot leave window.Swiper changed.
            */
            restorePreviousSwiperGlobal(previousSwiper);
            return;
          }

          const loadedSwiper = window.Swiper;
          restorePreviousSwiperGlobal(previousSwiper);

          if (typeof loadedSwiper !== 'function') {
            finishWithError('Swiper 12.2.0 loaded without exposing a valid constructor.');
            return;
          }

          settled = true;
          clearLoadTimeout();
          state.SwiperClass = loadedSwiper;
          resolve(loadedSwiper);
        }, { once: true });

        scriptElement.addEventListener('error', () => {
          finishWithError('Swiper 12.2.0 could not be loaded.');
        }, { once: true });

        if (!scriptParent) {
          finishWithError('The page has no valid location for the Swiper library.');
          return;
        }

        timeoutId = window.setTimeout(() => {
          finishWithError('Swiper 12.2.0 timed out while loading.');
        }, libraryLoadTimeoutMs);

        scriptParent.appendChild(scriptElement);
      });

      window[libraryRegistryName] = state;
      return state.promise;
    };

    const initSlider = (SwiperClass) => {
      if (controllerDestroyed) return;
      if (typeof sliderElement.isConnected === 'boolean' && !sliderElement.isConnected) return;

      const slides = sliderElement.querySelectorAll('.swiper-slide');

      if (!slides.length) {
        destroySlider();
        return;
      }

      const nextButton = sliderElement.querySelector('.slider-btn-next-bspdp-slider');
      const previousButton = sliderElement.querySelector('.slider-btn-prev-bspdp-slider');

      destroySlider();

      try {
        sliderInstance = new SwiperClass(sliderElement, {
          effect: 'coverflow',
          centeredSlides: true,
          grabCursor: true,
          watchOverflow: true,
          loop: true,
          initialSlide: 1,
          speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300,
          lazyPreloadPrevNext: 1,
          navigation: {
            addIcons: false,
            nextEl: nextButton,
            prevEl: previousButton
          },
          keyboard: {
            enabled: true,
            onlyInViewport: true
          },
          a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide'
          },
          coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 200,
            modifier: 1,
            slideShadows: false
          },
          breakpoints: {
            320: {
              slidesPerView: 1.5
            },
            768: {
              slidesPerView: 2
            },
            1024: {
              slidesPerView: 4
            }
          }
        });

        applyAccessibleSlideLabels(sliderInstance);
        sliderElement.classList.remove('preview');
      } catch (error) {
        sliderInstance = null;
        restorePreview();
        console.error(`Slider ${sectionId} failed to initialize.`, error);
      }
    };

    const initWhenReady = () => {
      if (controllerDestroyed) return;

      const requestToken = ++initRequestToken;

      loadSwiperLibrary()
        .then((SwiperClass) => {
          if (controllerDestroyed || requestToken !== initRequestToken) return;
          initSlider(SwiperClass);
        })
        .catch((error) => {
          if (controllerDestroyed || requestToken !== initRequestToken) return;
          restorePreview();
          console.error(`Slider ${sectionId} could not start.`, error);
        });
    };

    function handleSectionLoad(event) {
      if (eventContainsSlider(event)) initWhenReady();
    }

    function handleSectionUnload(event) {
      if (eventContainsSlider(event)) destroyController();
    }

    function destroyController() {
      if (controllerDestroyed) return;
      controllerDestroyed = true;
      initRequestToken += 1;

      destroySlider();
      document.removeEventListener('DOMContentLoaded', initWhenReady);
      document.removeEventListener('shopify:section:load', handleSectionLoad);
      document.removeEventListener('shopify:section:unload', handleSectionUnload);

      if (controllers[sectionId] && controllers[sectionId].destroy === destroyController) {
        delete controllers[sectionId];
      }
    }

    controllers[sectionId] = { destroy: destroyController };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWhenReady, { once: true });
    } else {
      initWhenReady();
    }

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', handleSectionLoad);
      document.addEventListener('shopify:section:unload', handleSectionUnload);
    }
  })();
